export default "__VITE_ASSET__DVRWWt2K__"